<template>
  <!-- Modal Structure -->
  <div id="modalMsgBottom" class="modal bottom-sheet" ref="ref_msg_modal_bottom1">
    <div class="modal-content">      
      <p>{{texts[value] || '-'}}</p>
    </div>
    <div class="modal-footer">
      <a
        href="#!"
        class="modal-close waves-effect waves-light btn-flat btn-small indigo lighten-5"
      >Закрыть</a>
    </div>
  </div>
</template>

<style scoped>
.modal { 
  max-height: 99%; 
}

</style>

<script>
export default {
  name: "msg_modal_bottom",
  props: ["value"],
  data: () => ({
    msg_modal_bottom1: null,
    texts: {
      mode_regime_hor:      
        `
        В заданиях-предложения на немецком и перевод на русском. Звучит аудиозапись произношения. 
        Внизу - пословный перевод, грамматика и формы глаголов для запоминания.         
        Для повторов аудиозаписи произношения можно нажимать кнопку ПРОИЗНОШЕНИЕ. 
        По кнопке ОК/ДАЛЕЕ - продолжайте, будут появляться следующие задания.
        Горизонтальная полоса вверху показывает прогресс по упражнению, 
        если более 80%, то упражнение автоматически отметится Пройдено. 
        Кнопка КУРС - прогресс по всем занятиям курса и рекомендуемое следующее занятие.
        Кнопка ПРОГРЕСС - графики и прогресс по этому упражнению. 
        Кнопка ПРЕДЛОЖЕНИЯ - список всех предложений.        
        В меню УПРАЖНЕНИЕ - вернуться к выполнению.    
        В меню ГРАММАТИКА - справочник по грамматике.            
        `,
      mode_regime_sp:
        `
        Нажмите кнопку РЕЧЬ-начнется запись голоса, и четко скажите в микрофон перевод предложения на немецком. 
        Затем нажмите кнопку СТОП. 
        Вы можете прослушать запись по кнопке ВОСПР. или, нажав ещё раз РЕЧЬ, записать ответ заново. 
        Затем для перевода записанного в текст нажмите кнопку В ТЕКСТ. 
        Через 2-3 секунды появится текст. Если нужно, то отредактируйте его на клавиатуре или запишите заново голосом. 
        Для ввода ответа нажмите кнопку ОК/ДАЛЕЕ. 
        Продолжайте в том же порядке: РЕЧЬ, говорим ответ, СТОП, В ТЕКСТ, ОК/ДАЛЕЕ, следующее задание - ещё раз ОК/ДАЛЕЕ.
        Ваш браузер должен иметь разрешение использовать микрофон. 
        Горизонтальная полоса вверху показывает прогресс по упражнению, 
        если более 80%, то упражнение автоматически отметится Пройдено. 
        Кнопка КУРС - прогресс по всем занятиям курса и рекомендуемое следующее занятие.
        Кнопка ПРОГРЕСС - графики и прогресс по этому упражнению. 
        Кнопка ПРЕДЛОЖЕНИЯ - список всех предложений.        
        В меню УПРАЖНЕНИЕ - вернуться к выполнению.    
        В меню ГРАММАТИКА - справочник по грамматике.                       
        `,
      mode_regime_sch:
        `
        В заданиях-предложения на русском. Переводите на немецкий, пишите ответ. 
        По кнопке ОК/ДАЛЕЕ - продолжайте, будут появляться следующие задания.
        Горизонтальная полоса вверху показывает прогресс по упражнению, 
        если более 80%, то упражнение автоматически отметится Пройдено. 
        Кнопка КУРС - прогресс по всем занятиям курса и рекомендуемое следующее занятие.
        Кнопка ПРОГРЕСС - графики и прогресс по этому упражнению. 
        Кнопка ПРЕДЛОЖЕНИЯ - список всех предложений.        
        В меню УПРАЖНЕНИЕ - вернуться к выполнению.    
        В меню ГРАММАТИКА - справочник по грамматике.                        
        `,
    }
  }),
  computed: {},
  mounted() {
    this.msg_modal_bottom1 = M.Modal.init(this.$refs.ref_msg_modal_bottom1);
  },
  beforeDestroy() {
    if (this.msg_modal_bottom1 && this.msg_modal_bottom1.destroy) {
      this.msg_modal_bottom1.destroy();
    }
  }
};
</script>
